// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Footer_footer__TL9Uz {
	width: 100%;
	background: var(--accent-color, #956446);

	padding: 6.25rem 10.31rem;

	display: flex;
	flex-direction: column;
	gap: 5rem;
}

.Footer_footer__navigation__STr0z {
	display: flex;
	justify-content: space-between;
}

.Footer_footer__links__832RP {
	display: flex;
	flex-direction: column;
	gap: 0.62rem;
}

.Footer_footer__link__kjTEK {
	color: var(--text-color, #fff);
	font-family: 'Noto Sans';
	font-size: 1.375rem;
	font-style: normal;
	font-weight: 400;
	line-height: 160%; /* 2.2rem */
	text-decoration-line: underline;
}

.Footer_footer__contact__wyRZN {
	color: var(--text-color, #fff);
	font-family: 'Noto Sans';
	font-size: 1.375rem;
	font-style: normal;
	font-weight: 400;
	line-height: 160%;
}

.Footer_footer__privacy__B\\+UL\\+ {
	display: flex;
	flex-direction: column;
	align-items: center;
	gap: 1.2rem;
}

.Footer_footer__copyright__YEIGu {
	display: flex;
	align-items: center;
	gap: 0.7rem;
}

.Footer_footer__divider__fOudl {
	width: 0.0625rem;
	height: 1.25rem;
	background: white;
}

.Footer_footer__copyright__YEIGu {
	color: var(--ui-white, #fff);

	/* text small */
	font-family: 'Noto Sans';
	font-size: 1rem;
	font-style: normal;
	font-weight: 400;
	line-height: 160%; /* 1.6rem */
}

.Footer_footer__sublink__Hueav {
	text-decoration: underline;
}

@media (max-width: 1440px) {
	.Footer_footer__link__kjTEK {
		font-size: 1.3rem;
	}
}

@media (max-width: 1280px) {
	.Footer_footer__TL9Uz {
		padding: 6.25rem 5rem;
	}
}

@media (max-width: 460px) {
	.Footer_footer__TL9Uz {
		flex-direction: column;
		padding: 4.38rem 1.25rem;
		align-items: center;
		gap: 2.5rem;
	}
	.Footer_footer__navigation__STr0z {
		flex-direction: column;
		align-items: center;
		text-align: center;
		gap: 0.8rem;
	}
	.Footer_footer__links__832RP {
		display: none;
	}
	.Footer_footer__links__832RP:last-child {
		display: flex;
	}

	.Footer_footer__copyright__YEIGu {
		flex-direction: column;
	}
	.Footer_footer__divider__fOudl {
		display: none;
	}

	.Footer_footer__privacy__B\\+UL\\+ {
		gap: 2.5rem;
	}
}
`, "",{"version":3,"sources":["webpack://./src/Components/Footer/Footer.module.css"],"names":[],"mappings":"AAAA;CACC,WAAW;CACX,wCAAwC;;CAExC,yBAAyB;;CAEzB,aAAa;CACb,sBAAsB;CACtB,SAAS;AACV;;AAEA;CACC,aAAa;CACb,8BAA8B;AAC/B;;AAEA;CACC,aAAa;CACb,sBAAsB;CACtB,YAAY;AACb;;AAEA;CACC,8BAA8B;CAC9B,wBAAwB;CACxB,mBAAmB;CACnB,kBAAkB;CAClB,gBAAgB;CAChB,iBAAiB,EAAE,WAAW;CAC9B,+BAA+B;AAChC;;AAEA;CACC,8BAA8B;CAC9B,wBAAwB;CACxB,mBAAmB;CACnB,kBAAkB;CAClB,gBAAgB;CAChB,iBAAiB;AAClB;;AAEA;CACC,aAAa;CACb,sBAAsB;CACtB,mBAAmB;CACnB,WAAW;AACZ;;AAEA;CACC,aAAa;CACb,mBAAmB;CACnB,WAAW;AACZ;;AAEA;CACC,gBAAgB;CAChB,eAAe;CACf,iBAAiB;AAClB;;AAEA;CACC,4BAA4B;;CAE5B,eAAe;CACf,wBAAwB;CACxB,eAAe;CACf,kBAAkB;CAClB,gBAAgB;CAChB,iBAAiB,EAAE,WAAW;AAC/B;;AAEA;CACC,0BAA0B;AAC3B;;AAEA;CACC;EACC,iBAAiB;CAClB;AACD;;AAEA;CACC;EACC,qBAAqB;CACtB;AACD;;AAEA;CACC;EACC,sBAAsB;EACtB,wBAAwB;EACxB,mBAAmB;EACnB,WAAW;CACZ;CACA;EACC,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,WAAW;CACZ;CACA;EACC,aAAa;CACd;CACA;EACC,aAAa;CACd;;CAEA;EACC,sBAAsB;CACvB;CACA;EACC,aAAa;CACd;;CAEA;EACC,WAAW;CACZ;AACD","sourcesContent":[".footer {\n\twidth: 100%;\n\tbackground: var(--accent-color, #956446);\n\n\tpadding: 6.25rem 10.31rem;\n\n\tdisplay: flex;\n\tflex-direction: column;\n\tgap: 5rem;\n}\n\n.footer__navigation {\n\tdisplay: flex;\n\tjustify-content: space-between;\n}\n\n.footer__links {\n\tdisplay: flex;\n\tflex-direction: column;\n\tgap: 0.62rem;\n}\n\n.footer__link {\n\tcolor: var(--text-color, #fff);\n\tfont-family: 'Noto Sans';\n\tfont-size: 1.375rem;\n\tfont-style: normal;\n\tfont-weight: 400;\n\tline-height: 160%; /* 2.2rem */\n\ttext-decoration-line: underline;\n}\n\n.footer__contact {\n\tcolor: var(--text-color, #fff);\n\tfont-family: 'Noto Sans';\n\tfont-size: 1.375rem;\n\tfont-style: normal;\n\tfont-weight: 400;\n\tline-height: 160%;\n}\n\n.footer__privacy {\n\tdisplay: flex;\n\tflex-direction: column;\n\talign-items: center;\n\tgap: 1.2rem;\n}\n\n.footer__copyright {\n\tdisplay: flex;\n\talign-items: center;\n\tgap: 0.7rem;\n}\n\n.footer__divider {\n\twidth: 0.0625rem;\n\theight: 1.25rem;\n\tbackground: white;\n}\n\n.footer__copyright {\n\tcolor: var(--ui-white, #fff);\n\n\t/* text small */\n\tfont-family: 'Noto Sans';\n\tfont-size: 1rem;\n\tfont-style: normal;\n\tfont-weight: 400;\n\tline-height: 160%; /* 1.6rem */\n}\n\n.footer__sublink {\n\ttext-decoration: underline;\n}\n\n@media (max-width: 1440px) {\n\t.footer__link {\n\t\tfont-size: 1.3rem;\n\t}\n}\n\n@media (max-width: 1280px) {\n\t.footer {\n\t\tpadding: 6.25rem 5rem;\n\t}\n}\n\n@media (max-width: 460px) {\n\t.footer {\n\t\tflex-direction: column;\n\t\tpadding: 4.38rem 1.25rem;\n\t\talign-items: center;\n\t\tgap: 2.5rem;\n\t}\n\t.footer__navigation {\n\t\tflex-direction: column;\n\t\talign-items: center;\n\t\ttext-align: center;\n\t\tgap: 0.8rem;\n\t}\n\t.footer__links {\n\t\tdisplay: none;\n\t}\n\t.footer__links:last-child {\n\t\tdisplay: flex;\n\t}\n\n\t.footer__copyright {\n\t\tflex-direction: column;\n\t}\n\t.footer__divider {\n\t\tdisplay: none;\n\t}\n\n\t.footer__privacy {\n\t\tgap: 2.5rem;\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"footer": `Footer_footer__TL9Uz`,
	"footer__navigation": `Footer_footer__navigation__STr0z`,
	"footer__links": `Footer_footer__links__832RP`,
	"footer__link": `Footer_footer__link__kjTEK`,
	"footer__contact": `Footer_footer__contact__wyRZN`,
	"footer__privacy": `Footer_footer__privacy__B+UL+`,
	"footer__copyright": `Footer_footer__copyright__YEIGu`,
	"footer__divider": `Footer_footer__divider__fOudl`,
	"footer__sublink": `Footer_footer__sublink__Hueav`
};
export default ___CSS_LOADER_EXPORT___;
